import React, { useState } from 'react';

const PhotoGridItem = ({ src, onClick }) => {
  const [hasError, setHasError] = useState(false);

  return (
    <button onClick={onClick} className="photoGrid__item">
      {hasError ? (
        <div className="photoGrid__placeholder" />
      ) : (
        <img
          src={src}
          alt=""
          onError={() => setHasError(true)}
        />
      )}
    </button>
  );
};

export default PhotoGridItem;
